import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

import { Option, SelectEvent } from '@models/index';

@Component({
  selector: 'app-select-field',
  standalone: true,
  imports: [
    MatSelectModule,
    MatFormFieldModule,
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatIconModule
  ],
  templateUrl: './select-field.component.html',
  styleUrl: './select-field.component.scss',
})
export class SelectFieldComponent implements OnInit {
  @Input() name = '';
  @Input() label = '';
  @Input() value: string | string[] = '';
  @Input() options: Array<Option> = [];
  @Input() customErrorMessage = '';
  @Input() multipleSelect = false;
  @Input() isRequired = false;
  @Output() selectEvent = new EventEmitter<SelectEvent>();
  public selectField = new FormControl(this.value);

  public handleSelectionChange(selectionChangeEvent: MatSelectChange): void {
    const noneSelected = selectionChangeEvent.value === '-1';

    this.selectEvent.emit({
      name: this.name,
      value: noneSelected ? '' : selectionChangeEvent.value,
      selectionChangeEvent
    });
  }

  ngOnInit(): void {
    const validators: ValidatorFn[] = [];

    if (this.isRequired) {
      validators.push(Validators.required, Validators.min(0))
    }
    
    this.selectField = new FormControl(this.value, validators);

    const noneSelected = this.value === '-1';
    this.selectEvent.emit({
      name: this.name,
      value: noneSelected? '': this.value,
      selectionChangeEvent: null
    });
  }

  ngOnChanges(changes: SimpleChanges): void {

    // Child must update AFTER options update, otherwise mat-select keeps old selection
    if (changes['options'] && !changes['options'].firstChange) {
      Promise.resolve().then(() => {
        if (this.selectField.value !== this.value) {
          this.selectField.setValue(this.value, { emitEvent: false });
        }
      });
    }
  }

  toArray(value: string | string[]): string[] {
    return Array.isArray(value) ? value : [value];
  }

  removeOption(option: string) {
    const options = this.selectField.value as string[];
    const index = options.indexOf(option)
    if (index !== -1) {
      options.splice(index, 1);
    }
    this.selectField.setValue(options)
  }

  getOptionValueById(id: string): string {
    const selectedOption = this.options.find(option => String(option.id) === String(id));
    return selectedOption ? selectedOption.value : '';
  }

}
